export const watch = {
  hoaId() {
    this.getRefreshedLotFileDocuments()
  },
  selectedRow(row) {
    if (this.isDebug == true) console.debug('selected', { row })

    if (row && row != undefined) {
      this.formData.lotFileDocumentID = row.lotFileDocumentID
      ;(this.formData.lotFileCategoryID = row.lotFileCategoryID),
        (this.formData.owner = row.owner.name)
      this.formData.address = row.unit.address.address1
      this.formData.documentID = row.documentID
      this.formData.category = this.selectedDocument.lotFileCategory.name
      this.formData.description = this.selectedDocument.description || ''
    }

    if (this.isDebug == true)
      console.debug('update formData values=' + JSON.stringify(this.formData))
  },
  async documentList() {
    await this.updateRows()
  }
}
